import {
  Column,
  Container,
  Img,
  Link,
  Row,
  Text,
} from '@react-email/components';
import Divider from './Divider';
import {
  KYDSocials,
  KYDSocialPlatforms,
} from '../../interfaces/KYDOrganization';

const Footer = ({
  src,
  organization_website,
  socials,
  unsubscribe_url,
  address,
}: {
  src: string;
  organization_website: string;
  socials?: KYDSocials;
  address?: string;
  unsubscribe_url?: string;
}) => {
  const style = getStyle();

  // Map of social platform keys to icon names
  const socialIconMap: Record<KYDSocialPlatforms, string> = {
    twitter: 'x',
    instagram: 'ig',
    spotify: 'spotify',
    youtube: 'youtube',
    soundcloud: 'soundcloud',
    applemusic: 'apple-music',
    tiktok: 'tiktok',
  };

  // Filter social platforms that exist and are enabled
  const availableSocials = socials
    ? Object.entries(socials)
        .filter(([_, value]) => value && value.enabled && value.link)
        .map(([key]) => key as KYDSocialPlatforms)
    : [];

  return (
    <>
      {socials && availableSocials.length > 0 && (
        <Container style={{ textAlign: 'center', padding: '16px 0' }}>
          <table
            role="presentation"
            cellPadding={0}
            cellSpacing={0}
            style={{ margin: '0 auto' }}
          >
            <tbody>
              <tr>
                {availableSocials.map(platform => {
                  const social = socials[platform];
                  const iconName = socialIconMap[platform] || platform;

                  return (
                    <td key={platform} style={{ padding: '0 12px' }}>
                      <Link href={social.link}>
                        <Img
                          width="40px"
                          height="40px"
                          src={`https://content.kydlabs.com/system/socials/${iconName}-icon.png`}
                          alt={`${platform} icon`}
                          style={{ display: 'block' }}
                        />
                      </Link>
                    </td>
                  );
                })}
              </tr>
            </tbody>
          </table>
        </Container>
      )}

      <Divider />

      {/* address line */}
      <Row style={{ margin: '12px 0', textAlign: 'center' }}>
        <Column style={{ textAlign: 'center' }}>
          <Text
            style={{
              ...style.text,
              color: '#000000CC',
              fontSize: '12px',
              margin: '0 auto',
            }}
          >
            {address}
            {organization_website && (
              <span style={{ color: '#000000CC' }}>
                {' '}
                •{' '}
                <Link
                  href={organization_website}
                  style={{ color: '#000000CC', textDecoration: 'underline' }}
                >
                  {organization_website}
                </Link>
              </span>
            )}
          </Text>
        </Column>
      </Row>

      <Row style={{ margin: '12px 0', textAlign: 'center' }}>
        <Column style={{ textAlign: 'center' }}>
          <Link
            href={unsubscribe_url}
            style={{
              color: '#000000CC',
              textDecoration: 'underline',
              fontSize: '12px',
            }}
          >
            Unsubscribe
          </Link>
        </Column>
      </Row>

      <Divider />

      {/* logo + footer text */}
      <Container style={{ textAlign: 'center' }}>
        <Row>
          <Img
            width="123px"
            src={src}
            alt="Logo"
            style={{ display: 'block', margin: '24px auto 0' }}
          />
        </Row>
        <Row>
          <Text
            style={{
              ...style.text,
              color: '#00000099',
              fontSize: '12px',
              margin: '8px 0 24px',
            }}
          >
            Powered by KYD LABS ©{new Date().getFullYear()} • All rights
            reserved
          </Text>
        </Row>
      </Container>
    </>
  );
};

const getStyle = () => ({
  text: {
    margin: 0,
    fontSize: '14px',
    lineHeight: '22px',
    color: 'black',
    textAlign: 'center' as const,
    fontFamily: 'Inter',
  },
});

export default Footer;
